export default __webpack_public_path__ + "static/media/waves_long.992521fe.svg";